import './../public/App_Themes/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import application from './../public/Resources/scripts/app.js'
import $event from './event.js'
import { createI18n } from 'vue-i18n'

var culture = localStorage.getItem("Culture");
if(!culture) {
  culture = 'fr';
}

const i18n = createI18n({
    locale: culture, // 'fr',
    allowComposition: false, // true  you need to specify that!
    messages: {
      en: {
        hello: 'page Home.'
      },
      fr: {
        hello: 'page accueil.'
      }
    }
})

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as filters from './filters.js'

import header from './components/header.vue'
import footer from './components/footer.vue'

const app = createApp(App)
app.component('Header', header);
app.component('Footer', footer);

const vuetify = createVuetify({
    components,
    directives,
});
app.use(vuetify);
app.use(application);
if(!$App.event){ $App.event = $event; }
app.use(router)
app.use(i18n)

// Initialize the $filters object
app.config.globalProperties.$filters = {};

// Register filters
Object.keys(filters).forEach(key => {
  app.config.globalProperties.$filters[key] = filters[key];
});

app.mount('#app')
